import styled from 'styled-components';
import { colors } from '../colors';

interface tableDataProps {
	width?: string;
	borderBottom?: string;
	paddingLeft?: string;
	maxWidth?: string;
}
const TableData = styled.td<tableDataProps>`
	text-align: left;
	font-weight: normal;
	font-size: 13px;
	color: #58728c;
	padding: 14px 15px 14px 33px;
	border-bottom: 1px solid ${colors.Border2};
	transition: ease all 0.4s;
	width: ${({ width }) => width}!important;
	border-bottom: ${({ borderBottom }) => borderBottom}!important;
	padding-left: ${({ paddingLeft }) => paddingLeft}!important;
	max-width: ${({ maxWidth }) => maxWidth}!important;
	overflow: hidden;
	word-break: break-word;
	white-space: normal;
	:last-child {
		width: 200px;
		text-align: center !important;
	}
	:hover {
		td {
			background: #e6f4ff !important;
		}
	}
	th {
		width: ${({ width }) => width}!important;
	}
	button {
		cursor: pointer;
		display: inline-block;
		margin-left: 10px;
		padding: 4px 6px;
		transition: ease-in all 0.3s;
		:hover,
		:focus {
			background: #55a8fe;
			border: 1px solid #55a8fe;
			color: ${colors.White};
			span,
			span::before {
				color: ${colors.White};
			}
		}
	}
`;

export default TableData;
